export function addProductOrderCard(info) {
    const card = document.createElement('div');
    card.classList.add('product-card-order');
    card.dataset.id = info.product_id;
    
    let bonusesCount = '';
    if(!!info.bonuses_count) {
        bonusesCount = `
            <div class="product-card-order__info-block__price-block__tag">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5998 5.40006C12.7771 5.16368 12.9061 4.8947 12.9794 4.60847C13.0527 4.32224 13.069 4.02436 13.0272 3.73186C12.9854 3.43936 12.8864 3.15795 12.7359 2.9037C12.5853 2.64945 12.3862 2.42734 12.1498 2.25006C11.9134 2.07277 11.6444 1.94378 11.3582 1.87045C11.072 1.79712 10.7741 1.78089 10.4816 1.82267C10.1891 1.86446 9.90769 1.96345 9.65344 2.11399C9.3992 2.26453 9.17709 2.46368 8.9998 2.70006C8.64176 2.22267 8.10874 1.90706 7.518 1.82267C6.92726 1.73828 6.32719 1.89202 5.8498 2.25006C5.37242 2.6081 5.05681 3.14112 4.97242 3.73186C4.88803 4.3226 5.04176 4.92267 5.3998 5.40006H2.9248C2.3038 5.40006 1.7998 5.90406 1.7998 6.52506V6.97506C1.7998 7.59606 2.3038 8.10006 2.9248 8.10006H8.3248V5.40006H9.67481V8.10006H15.0748C15.6958 8.10006 16.1998 7.59606 16.1998 6.97506V6.52506C16.1998 5.90406 15.6958 5.40006 15.0748 5.40006H12.5998ZM11.6998 4.05006C11.6998 4.28875 11.605 4.51767 11.4362 4.68645C11.2674 4.85524 11.0385 4.95006 10.7998 4.95006H9.89981V4.05006C9.89981 3.81136 9.99463 3.58244 10.1634 3.41366C10.3322 3.24488 10.5611 3.15006 10.7998 3.15006C11.0385 3.15006 11.2674 3.24488 11.4362 3.41366C11.605 3.58244 11.6998 3.81136 11.6998 4.05006ZM6.2998 4.05006C6.2998 4.28875 6.39463 4.51767 6.56341 4.68645C6.73219 4.85524 6.96111 4.95006 7.1998 4.95006H8.0998V4.05006C8.0998 3.81136 8.00498 3.58244 7.8362 3.41366C7.66742 3.24488 7.4385 3.15006 7.1998 3.15006C6.96111 3.15006 6.73219 3.24488 6.56341 3.41366C6.39463 3.58244 6.2998 3.81136 6.2998 4.05006Z" fill="#0BD20B"/>
                    <path d="M8.3252 9.44995H2.7002V13.725C2.7002 14.3814 2.96095 15.0109 3.42511 15.475C3.88926 15.9392 4.51878 16.2 5.1752 16.2H8.3252V9.44995ZM9.6752 16.2V9.44995H15.3002V13.725C15.3002 14.3814 15.0394 15.0109 14.5753 15.475C14.1111 15.9392 13.4816 16.2 12.8252 16.2H9.6752Z" fill="#0BD20B"/>
                </svg>
                ${info.bonuses_count} ₽
            </div>
        `;
    };
    let basePrice = '';
    if(info.price !== info.base_price) {
        let percentsDiscount = '';
        if(info.is_percent_discount) percentsDiscount = `data-percent="-${info.discount}%"`
        basePrice = `
            <div class="product-card-order__info-block__price-block__price_prev" ${percentsDiscount}>
                <span>${info.base_price}</span>
            </div>
        `;
    }

    const photo = info.main_photo ? info.main_photo : '/static/assets/images/stub.webp';
    card.innerHTML = `
        <div class="product-card-order__image">
            <img src="${photo}" alt="product image">
        </div>
        <div class="product-card-order__info-block">
            <div class="product-card-order__info-block__price-block">
                <div class="product-card-order__info-block__price-block__main">
                    <div class="product-card-order__info-block__price-block__price">
                        ${info.price} ₽
                    </div>

                    ${bonusesCount}
                </div>
                ${basePrice}
            </div>
            <div class="product-card-order__info-block__title-block">
                ${info.name}
            </div>
        </div>
    `;

    return card;
}